<template>
  <div>
    <beautiful-chat
      v-if="messages"
      :participants="participants"
      :onMessageWasSent="onMessageWasSent"
      :title="parent.fullName() "
      :placeholder="'メッセージを書く'"
      :messageList="messageList"
      :newMessagesCount="newMessagesCount"
      :isOpen="isOpen"
      :close="close"
      :open="open"
      :showEmoji="false"
      :showFile="false"
      :showTypingIndicator="''"
      :colors="colors"
      :alwaysScrollToBottom="true"
      :messageStyling="true"
      @onType="handleOnType"
      @edit="editMessage"
    />
  </div>
</template>

<script>
import { MessageRepository } from "@/repository/MessageRepository.js"
import { firestore } from "@/repository/client/firestore.js"

export default {
  name: "MessageFromParent",
  props: {
    parent: Object,
    isOpen: Boolean
  },
  data () {
    return {
      teacher: null,
      messageRepo: null,
      messages: null,
      participants: [],
      colors: {
        header: {
          bg: '#4e8cff',
          text: '#ffffff'
        },
        launcher: {
          bg: '#4e8cff'
        },
        messageList: {
          bg: '#ffffff'
        },
        sentMessage: {
          bg: '#4e8cff',
          text: '#ffffff'
        },
        receivedMessage: {
          bg: '#eaeaea',
          text: '#222222'
        },
        userInput: {
          bg: '#f4f7f9',
          text: '#565867'
        }
      },
      newMessagesCount: 0,
    }
  },
  methods: {
    open() {
      this.$emit('open', parent)
      this.newMessagesCount = 0
    },
    close() {
      this.$emit('close')
    },
    async onMessageWasSent(message) {
      await this.messageRepo.sendMessage(
        this.teacher.uuid,
        this.parent.uuid,
        message.data.text
      )
    },
    handleOnType () {
    },
    editMessage(message){
      const m = this.messageList.find(m => m.id === message.id)
      m.isEdited = true
      m.data.text = message.data.text
    },
  },
  mounted: async function() {
    this.teacher = this.$store.getters.teacher
    this.messageRepo = new MessageRepository(firestore)
    this.participants = [
      {
        id: this.parent.uuid,
        name: this.parent.fullName(),
      },
      {
        id: this.teacher.uuid,
        name: this.teacher.fullName(),
      }
    ]
    this.messages = await this.messageRepo.startWatching(this.teacher.uuid, this.parent.uuid)
  },
  beforeDestroy: async function() {
    await this.messageRepo.stopWatching()
  },
  computed: {
    messageList: {
      get() {
        return this.messages.talkList(this.teacher.uuid)
      }
    }
  }
}

</script>

